/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Project_RkidInputs */

const cs_form_project_rkid = /** @type {(inputs: Form_Project_RkidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RK ID developerského projektu`)
};

const en_form_project_rkid = /** @type {(inputs: Form_Project_RkidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developer project RK ID`)
};

/**
* | output |
* | --- |
* | "Developer project RK ID" |
*
* @param {Form_Project_RkidInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_project_rkid = /** @type {((inputs?: Form_Project_RkidInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Project_RkidInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_project_rkid(inputs)
	return cs_form_project_rkid(inputs)
});